import './index.scss'
import '@fancyapps/fancybox/dist/jquery.fancybox.min'
// $(document).ready(function(){

//   //进入页面默认选择全部
//   $('.select-cont .select-all a').addClass('active')
//   $('.section2 .cont-item').addClass('active')

//   //产品类型选择,显示产品系列
//   $('.select-cont.pro-type .select-option').on('click','a',function(){
//     let $parentsEl = $(this).parents('.select-cont')
//     let data = $(this).html()
//     //取消全选
//     $parentsEl.find('.select-all a').removeClass('active')
//     //选择高亮
//     $(this).addClass('active').siblings().removeClass('active')
//     //显示产品系列
//     $('.select-cont.pro-series').slideDown()
//     $('.select-cont.pro-series .select-all a').addClass('active')
//     $('.select-cont.pro-series .select-option a').removeClass('active')
//     $('.select-show .select-set a.pro-series-r').remove()
//     proModelUp()
//     //添加到已选条件
//     // 判断是否已显示产品类型，已显示则修改显示内容，未显示则显示
//     if($('.select-show .select-set a.pro-type-r').length > 0){
//       $('.select-show .select-set a.pro-type-r').html(data)
//     }else{
//       let html = `<a href="javascript:void(0)" class="pro-type-r">${data}</a>`
//       $('.select-show .select-set').append(html)
//     }
//     isHasSelect()
//   })
//   //产品系列选择,显示产品型号
//   $('.select-cont.pro-series .select-option').on('click','a',function(){
//     let $parentsEl = $(this).parents('.select-cont')
//     let data = $(this).html()
//     //取消全选
//     $parentsEl.find('.select-all a').removeClass('active')
//     //选择高亮
//     $(this).addClass('active').siblings().removeClass('active')
//     //显示产品型号
//     $('.select-cont.pro-model').slideDown()
//     $('.select-cont.pro-model .select-all a').addClass('active')
//     $('.select-cont.pro-model .select-option a').removeClass('active')
//     $('.select-show .select-set a.pro-model-r').remove()
//     //添加到已选条件
//     // 判断是否已显示产品系列，已显示则修改显示内容，未显示则显示
//     if($('.select-show .select-set a.pro-series-r').length > 0){
//       $('.select-show .select-set a.pro-series-r').html(data)
//     }else{
//       let html = `<a href="javascript:void(0)" class="pro-series-r">${data}</a>`
//       $('.select-show .select-set').append(html)
//     }
//   })
//   //产品型号选择
//   $('.select-cont.pro-model .select-option').on('click','a',function(){
//     let $parentsEl = $(this).parents('.select-cont')
//     let data = $(this).html()
//     //取消全选
//     $parentsEl.find('.select-all a').removeClass('active')
//     //选择高亮
//     $(this).addClass('active').siblings().removeClass('active')
//     //添加到已选条件
//     // 判断是否已显示产品型号，已显示则修改显示内容，未显示则显示
//     if($('.select-show .select-set a.pro-model-r').length > 0){
//       $('.select-show .select-set a.pro-model-r').html(data)
//     }else{
//       let html = `<a href="javascript:void(0)" class="pro-model-r">${data}</a>`
//       $('.select-show .select-set').append(html)
//     }
//   })
//   //文件类型选择，可多选
//   $('.select-cont.file-type .select-option').on('click','a',function(){
//     let $parentsEl = $(this).parents('.select-cont')
//     let data = $(this).html()
//     let index = $(this).data('index')
//     // 判断是否已有已选项
//     if($parentsEl.find('.select-option a.active').length > 0){
//       // 判断点击的是否是已选项
//       if($(this).hasClass('active')){
//         //是已选项，取消高亮
//         $(this).removeClass('active')
//         //删除已选条件
//         $('.select-show .select-set a[data-index='+ index +']').remove()
//         //隐藏对应列表
//         $('.section2 .cont-item').eq(index).hide()
//       }else{
//         //不是已选项，添加高亮
//         $(this).addClass('active')
//         //添加到已选条件
//         let html = `<a href="javascript:void(0)" data-index="${index}" class="file-type-r">${data}</a>`
//         $('.select-show .select-set').append(html)
//         //显示对应列表
//         $('.section2 .cont-item').eq(index).show().addClass('active').find('.item-list').slideDown()
//       }
//     }else{
//       //没有已选项
//       //取消全选
//       $parentsEl.find('.select-all a').removeClass('active')
//       //选择高亮
//       $(this).addClass('active')
//       //添加到已选条件
//       let html = `<a href="javascript:void(0)" data-index="${index}" class="file-type-r">${data}</a>`
//       $('.select-show .select-set').append(html)
//       //显示对应列表
//       $('.section2 .cont-item').eq(index).show().find('.item-list').slideDown()
//       $('.section2 .cont-item').eq(index).siblings().hide()
//     }
//     fileTypeIsAll()
//     isHasSelect()
//   })

//   //点击全选
//   $('.select-cont .select-all a').on('click',function(){
//     $(this).addClass('active')
//     let $parentsEl = $(this).parents('.select-cont')
//     $parentsEl.find('.select-option a').removeClass('active')

//     if($parentsEl.hasClass('pro-type')){
//       $('.select-show .select-set .pro-type-r').remove()
//       proSeriesUp()
//       proModelUp()
//     }
//     if($parentsEl.hasClass('pro-series')){
//       $('.select-show .select-set .pro-series-r').remove()
//       proModelUp()
//     }
//     if($parentsEl.hasClass('pro-model')){
//       $('.select-show .select-set .pro-model-r').remove()
//     }
//     if($parentsEl.hasClass('file-type')){
//       $('.select-show .select-set a[data-index]').remove()
//       $('.section2 .cont-item').show()
//     }
//     isHasSelect()
//   })

//   //点击清空选择
//   $('.select-show .select-btn').on('click',function(){
//     proSeriesUp()
//     proModelUp()
//     $('.select-show .select-set').html('')
//     $('.select-show').slideUp()
//     $('.select-cont .select-option a').removeClass('active')
//     $('.select-cont .select-all a').addClass('active')
//     $('.section2 .cont-item').show()
//   })
//   //点击已选条件
//   $('.select-show .select-set').on('click','a',function(){
//     if($(this).hasClass('pro-type-r')){
//       $('.select-cont.pro-type .select-all a').addClass('active')
//       $('.select-cont.pro-type .select-option a').removeClass('active')
//       proSeriesUp()
//       proModelUp()
//     }
//     if($(this).hasClass('pro-series-r')){
//       $('.select-cont.pro-series .select-all a').addClass('active')
//       $('.select-cont.pro-series .select-option a').removeClass('active')
//       proModelUp()
//     }
//     if($(this).hasClass('pro-model-r')){
//       $('.select-cont.pro-model .select-all a').addClass('active')
//       $('.select-cont.pro-model .select-option a').removeClass('active')
//     }
//     if($(this).hasClass('file-type-r')){
//       let index = $(this).data('index')
//       //取消选择高亮
//       $('.select-cont.file-type .select-option a').eq(index).removeClass('active')
//       //隐藏对应列表
//       $('.section2 .cont-item').eq(index).hide()
//       fileTypeIsAll()
//     }
//     $(this).remove()
//     isHasSelect()
//   })

//   //列表伸缩
//   $('.section2 .cont').on('click','.cont-item .item-title',function(){
//     let $parentsEl = $(this).parents('.cont-item')
//     if($parentsEl.hasClass('active')){
//       $parentsEl.removeClass('active').find('.item-list').slideUp()
//     }else{
//       $parentsEl.addClass('active').find('.item-list').slideDown()
//     }
//   })
// })

// //判断已选条件是否显示
// function isHasSelect(){
//   if($('.select-show .select-set a').length < 1){
//     $('.select-show').slideUp()
//   }else{
//     $('.select-show').slideDown()
//   }
// }

// //收起产品型号选项
// function proModelUp(){
//   $('.select-cont.pro-model .select-all a').addClass('active')
//   $('.select-cont.pro-model .select-option a').removeClass('active')
//   $('.select-show .select-set .pro-model-r').remove()
//   $('.select-cont.pro-model').slideUp()
// }
// //收起产品系列选项
// function proSeriesUp(){
//   $('.select-cont.pro-series .select-all a').addClass('active')
//   $('.select-cont.pro-series .select-option a').removeClass('active')
//   $('.select-show .select-set .pro-series-r').remove()
//   $('.select-cont.pro-series').slideUp()
// }

// //判断文件类型是否全选
// function fileTypeIsAll(){
//   if($('.select-cont.file-type .select-option a.active').length < 1){
//     $('.select-cont.file-type .select-all a').addClass('active')
//     $('.section2 .cont-item').show()
//     $('.section2 .cont-item').addClass('active').find('.item-list').slideDown()
//   }
// }


// 移动端显示选择项
$('.mob-search .show-select').on('click',function(){
  $('.section1').addClass('active')
  $('.job-mask').fadeIn(400)
})
$('.section1 .mob-btn >div').on('click',function(){
  $('.section1').removeClass('active')
  $('.job-mask').fadeOut(400)
})
$('.job-mask').on('click',function(){
  $('.section1').removeClass('active')
  $('.job-mask').fadeOut(400)
})